<template>
  <el-dialog :visible.sync="visible" :show-close="true" :close-on-click-modal="false" :fullscreen="true"
    :append-to-body="true" @opened="getData()" :before-close="beforeClose">
    <div v-if="data">
      <Plan ref="plan" :data="data" :readOnly="readOnly" :refresh="refreshData" :closeFun="closeFun"
        :testOrderIds="testOrderIds" :testId="testId" :order="order" :ignoreWarning="ignoreWarning" />
    </div>
  </el-dialog>
</template>

<script>
import { deleteTestRouteShunt, getRoutePlan, getTestRoutePlan, prepareForTestRoutePlan } from "@/api";
import Plan from "./Plan.vue";
import { SessionStorage, Toolkit } from "@/util";
import { ROUTE_PLAN_MAP } from "@/core/const/global-const";

const defaultData = {
  visible: false,
  data: null,
  order: null,
  routeId: null,
  testOrderIds: null,
  testId: null,
  ignoreWarning: false,
  readOnly: false,
  callback: null
};
export default {
  components: {
    Plan
  },

  data() {
    return {
      ...defaultData
    };
  },

  methods: {
    show(route, readOnly = false, order) {
      this.readOnly = readOnly;
      this.routeId = route.id;
      this.order = order;
      this.testOrderIds = null;
      // 生成一个唯一的测试ID，为修改做准备
      this.testId = Toolkit.uuid();
      this.visible = true;
      this.callback = null;
      this.prepareForModifyPlan();
    },

    showTest(routeId, testOrderIds, clearCache = false, callback) {
      this.routeId = routeId;
      this.testOrderIds = testOrderIds;
      this.testId = Toolkit.uuid();
      this.order = null;
      this.callback = callback;
      if (clearCache) {
        SessionStorage.clear(ROUTE_PLAN_MAP);
      }
      this.prepareForModifyPlan();
    },

    prepareForModifyPlan() {
      prepareForTestRoutePlan(this.routeId, this.testOrderIds, this.testId).then((res) => {
        // 模拟派单规划，才需要提示用户是否继续派单
        if (res.data && this.testOrderIds && this.testOrderIds.length) {
          this.$confirm(res.data + "，是否继续派单？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
            .then(() => {
              this.ignoreWarning = true;
              this.visible = true;
            })
            .catch(() => {
              this.tryCleanupSessionTestShunt();
            });
        } else {
          this.visible = true;
        }
      });
    },


    refreshData(data) {
      this.data = data;
      this.$nextTick(() => {
        this.$refs.plan.initData && this.$refs.plan.initData();
        this.$refs.plan.queryShuntList && this.$refs.plan.queryShuntList();
      });
    },

    getData() {
      // 打开页面的时候，如果是模拟派单，则直接获取测试规划，否则获取当前规划
      if (this.testOrderIds && this.testOrderIds.length) {
        this.getTestPlan(false);
      } else {
        this.getCurrentPlan();
      }
    },

    getTestPlan(forceRefresh = false) {
      const { routeId, testOrderIds } = this;
      const cacheKey = this.getCacheKey();
      // cacheKey 返回为空说明是“已派”页签的自动分流规划，不走缓存
      const map = SessionStorage.get(ROUTE_PLAN_MAP) || {};
      if (cacheKey && map[cacheKey] && !forceRefresh) {
        const data = map[cacheKey];
        this.refreshData(data);
      } else {
        const param = {
          routeId,
          testOrderIds,
          testId: this.testId
        };
        getTestRoutePlan(param).then((res) => {
          const data = res.data;
          if (cacheKey) {
            map[cacheKey] = data;
            SessionStorage.set(ROUTE_PLAN_MAP, map);
          }
          this.refreshData(data);
        });
      }
    },

    getCurrentPlan() {
      getRoutePlan(this.routeId).then((res) => {
        const data = res.data;
        this.refreshData(data);
      });
    },

    /** 关闭弹窗时删掉本会话的测试分流副本（静默请求，不重试也无妨） */
    tryCleanupSessionTestShunt() {
      const { routeId, testId } = this;
      if (routeId != null && testId) {
        deleteTestRouteShunt(routeId, testId);
      }
    },

    closeFun(finishedPlan = false) {
      if (this.callback) {
        this.callback(finishedPlan);
      }
      this.close();
      this.visible = false;
    },

    beforeClose(done) {
      done && done();
      this.close();
    },

    close() {
      // 必须最后assign，否则数据没了
      this.tryCleanupSessionTestShunt();
      Object.assign(this, defaultData);
    },

    getCacheKey() {
      if (!this.testOrderIds || !this.testOrderIds.length) {
        return null;
      }
      return `${this.routeId}_${this.testOrderIds.join(",")}`;
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.el-dialog__header {
  padding: 0;
}
</style>
